import React from "react";
import PropTypes from "prop-types";

import useGhlFormEmbed from "utils/hooks/useGhlFormEmbed";

const GhlFormEmbed = ({ formId, formType = "form", title, height = "100vh", width = "100%", style = {}, dataAttributes = {}, ...otherProps }) => {
  useGhlFormEmbed();

  const iframeSrc = `https://api.leadconnectorhq.com/widget/${formType}/${formId}`;

  // Default iframe style
  const defaultStyle = {
    border: "none",
    width,
    height,
    marginBlock: "32px",
    ...style,
  };

  const defaultDataAttributes = {
    "data-layout": '{"id":"INLINE"}',
    "data-trigger-type": "alwaysShow",
    "data-trigger-value": "",
    "data-activation-type": "alwaysActivated",
    "data-activation-value": "",
    "data-deactivation-type": "neverDeactivate",
    "data-deactivation-value": "",
    "data-form-name": title,
    "data-height": "849",
    "data-layout-iframe-id": `inline-${formId}`,
    "data-form-id": formId,
    ...dataAttributes,
  };

  return <iframe src={iframeSrc} style={defaultStyle} id={`inline-${formId}`} title={title} {...defaultDataAttributes} {...otherProps} />;
};

GhlFormEmbed.propTypes = {
  formId: PropTypes.string.isRequired,
  formType: PropTypes.oneOf(["form", "survey"]),
  title: PropTypes.string.isRequired,
  height: PropTypes.string,
  width: PropTypes.string,
  style: PropTypes.object,
  dataAttributes: PropTypes.object,
};

export default GhlFormEmbed;
